import LabServiceCollection from "../LabServiceCollection";
import PermissionModel from "@/models/lab/PermissionModel";

export default class PermissionCollection extends LabServiceCollection {
  model() {
    return PermissionModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.defaultSortAddAsc("name");
  }
}
